<template>
    <!-- 典型案例 -->
    <div class="case">
        <div class="case-item" v-for="item in list" @click="handleJumpDetail(item.key)">
            <div class="case-left">
                <template v-if="Array.isArray(item.image)">
                    <img class="double" v-for="it in item.image" :src="require(`@/assets/img/${it}`)" alt="">
                </template>
                <template v-else>
                    <img :src="require(`@/assets/img/${item.image}`)" alt="">
                </template>
                <div class="title">{{ item.title }}</div>
            </div>
            <div class="case-right">
                <div class="desc">{{ item.desc }}</div>
                <div style="white-space:pre-line" class="content">{{ item.content }}</div>
                <div class="more">{{ $t('case.more') }}</div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'Case',
    props: {
    },
    computed: {
        list() {
            return this.$t('case.list');
        }
    },
    methods: {
        handleJumpDetail(id) {
            this.$router.push(`/case/${id}`);
        }
    }
}
</script>
  
<style scoped>
.case {
    padding-top: 26px;
}

.case-item {
    display: flex;
    margin-bottom: 20px;
    padding: 65px 35px 40px;
    border: 1px solid #AEAEAE;
    cursor: pointer;
}

.case-left {
    width: 443px;
}

.case-item img {
    width: 443px;
    height: 295px;
}

.double {
    height: 150px !important;
}

.case-item .case-left {
    margin-right: 64px;
}

.title {
    margin-top: 14px;
    text-align: center;
    font-size: 18px;
}

.desc {
    margin-bottom: 30px;
    font-size: 20px;
}

.content {
    font-size: 16px;
}

.more {
    margin-top: 20px;
    color: #409EFF;
}
</style>
  